import React from 'react';
import { useParams } from 'react-router-dom';
import { Card } from '../../../components/ui/card';
import { Button } from '../../../components/ui/button';
import { Boxes, ExternalLink } from 'lucide-react';

export default function AppsTools() {
  const { orgId } = useParams();

  const apps = [
    {
      id: 1,
      name: 'OpenAI Integration',
      description: 'Connect your OpenAI API for enhanced AI capabilities',
      category: 'AI & ML',
      installed: false,
    },
    {
      id: 2,
      name: 'Slack Integration',
      description: 'Sync notifications and updates to Slack channels',
      category: 'Communication',
      installed: false,
    },
    {
      id: 3,
      name: 'Analytics Dashboard',
      description: 'Advanced analytics and reporting tools',
      category: 'Analytics',
      installed: false,
    },
  ];

  return (
    <div className="p-8 space-y-6" data-testid="apps-tools-page">
      <div>
        <h1 className="font-heading text-3xl font-bold text-gray-900">Apps & Tools</h1>
        <p className="text-gray-600 mt-1">Integrate third-party services and tools</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {apps.map((app) => (
          <Card key={app.id} className="p-6 rounded-lg hover:shadow-md transition-all">
            <div className="flex items-start justify-between mb-4">
              <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center">
                <Boxes className="w-5 h-5 text-primary" />
              </div>
              {app.installed && (
                <span className="text-xs px-2 py-1 rounded-full bg-success/10 text-success">
                  Installed
                </span>
              )}
            </div>
            <h3 className="font-heading text-lg font-semibold text-gray-900 mb-1">
              {app.name}
            </h3>
            <p className="text-sm text-gray-600 mb-3">{app.description}</p>
            <div className="flex items-center justify-between">
              <span className="text-xs text-gray-500">{app.category}</span>
              <Button size="sm" variant="outline">
                {app.installed ? 'Configure' : 'Install'}
              </Button>
            </div>
          </Card>
        ))}
      </div>

      <Card className="p-6 rounded-lg">
        <h3 className="font-heading text-lg font-semibold text-gray-900 mb-4">
          API Keys Management
        </h3>
        <p className="text-sm text-gray-600 mb-4">
          Generate and manage API keys for programmatic access to HumaTwin
        </p>
        <Button variant="outline">
          Generate API Key
        </Button>
        <div className="mt-4 p-4 bg-gray-50 rounded-lg">
          <p className="text-xs text-gray-500 font-mono">
            No API keys generated yet
          </p>
        </div>
      </Card>
    </div>
  );
}
